import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import BtnV2 from '../../BtnV2'

import cm from './Modal.module.css'

export const CloseButton = ({ onClick, withHeaderButtons, dataTestId }) => (
  <BtnV2
    variant="ghost-light"
    size="default"
    onlyIcon="Close"
    onClick={onClick}
    className={cx(cm.close, {
      [cm.closeWithHeaderButtons]: withHeaderButtons,
      [cm.closeWithoutHeaderButtons]: !withHeaderButtons,
    })}
    data-test-id={dataTestId}
  />
)

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  withHeaderButtons: PropTypes.bool,
  dataTestId: PropTypes.string,
}
